// The Team screen's calls, all under /api/cms/staff/** (staff.StaffController, admins only). Every
// function answers the response body; kept in one module so the screen can be tested against a
// mocked API, the same shape PersonAdminApi has.
import api from '../../utils/authUtils';

// -> [{accountId, email, role: 'ADMIN' | 'TEAM', personId, name, lastActivityAt}]
export const fetchStaff = () => api.get('/api/cms/staff').then((r) => r.data);

// Accounts by email or name (at least 2 characters), the same rows with role MEMBER for non-staff.
export const searchAccounts = (query) => api.get('/api/cms/staff/accounts', { params: { query } }).then((r) => r.data);

// role: 'ADMIN', 'TEAM' or 'MEMBER' (takes the staff role away). 409 for the last admin.
export const setRole = (accountId, role) => api.put(`/api/cms/staff/accounts/${accountId}/role`, { role }).then((r) => r.data);

// -> [{id, accountId, occurredAt, method, path, status}], newest first; accountId optional.
export const fetchActivity = (accountId, limit = 50) => api
  .get('/api/cms/staff/activity', { params: accountId ? { accountId, limit } : { limit } }).then((r) => r.data);

// -> [{key, roles}]: what each role may do (authority.Permission).
export const fetchPermissionTable = () => api.get('/api/cms/staff/permissions').then((r) => r.data);
